// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3i8LV","location":"Header_location__3Ti8k"};